import template from './accountUpdatesAndReminders.template.html';

export default {
  template,
  bindings: {
    account: '<',
    organization: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $timeout, $mdMedia) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.account = ctrl.account || {};
        ctrl.organization = ctrl.organization || {};
        ctrl.isReady = true;
      };

      ctrl.saveAccount = (group, subgroup, type) => {
        $timeout(() => {
          if (type === 'ee' || type === 'es') {
            const neighbor = ctrl.account.notifications[group][subgroup][type];
            if (neighbor) {
              if (type !== 'ee') {
                ctrl.account.notifications[group][subgroup].ee = !neighbor;
              }
              if (type !== 'es') {
                ctrl.account.notifications[group][subgroup].es = !neighbor;
              }
            }
          }
          const data = {
            id: ctrl.account?.id,
            notifications: ctrl.account?.notifications || {}
          };
          ctrl.onFinished({ data });
        });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
